/*@flow*/
import React, { useState, Fragment, useEffect, useContext } from 'react';
import ResourceForm from './';
import FreeModal from 'comps/FreeModal';
import { hocShell } from '../Shell';
import commands from '../commands';
import BuilderContext from '../Context';

type PropsT = {
  id: any,
  title: string,
  resource: Object,
  children: any,
  className: string,
  resourceName: string,
};

const Component = (props: PropsT) => {
  const [isOpen, setOpen] = useState(false);
  const { className, children, resource, resourceName, id, title } = props;
  const ctx = useContext(BuilderContext);

  useEffect(() => {
    if (!resourceName) return;
    commands(ctx).editResource({ id, resourceName });
  }, [resourceName]);

  const requestClosePortal = () => setOpen(v => !v);

  return (
    <Fragment>
      <button
        className={className}
        onClick={() => {
          commands(ctx).newResource({ resourceName, resource });
          setOpen(v => !v);
        }}
      >
        {children}
      </button>
      <FreeModal
        id="resourceFormModal"
        isOpen={isOpen}
        title={title}
        requestClosePortal={requestClosePortal}
      >
        <ResourceForm requestClosePortal={requestClosePortal} />
      </FreeModal>
    </Fragment>
  );
};

export default (hocShell<PropsT>(Component): React$StatelessFunctionalComponent<PropsT>);
